import { z } from 'zod';
import { toFlatField } from '../oasis-types';
export const HomeboundVersioned = {
    homebound: { e1: { alias: 'homebound', timepoint: ['soc', 'roc', 'rct'] } },
};
export const Homebound = toFlatField(HomeboundVersioned);
export const baseHomebound = z.object({
    homeboundConditions: z.array(z.string()).optional(),
    homeboundMobility: z.array(z.string()).optional(),
    absenceFrequency: z.string().optional(),
    absenceDuration: z.string().optional(),
    absencePurpose: z.array(z.string()).optional(),
    absenceNarrative: z.string().optional(),
    effortFactors: z.array(z.string()).optional(),
    effortFactorsOther: z.string().optional(),
    homeboundConditionsOther: z.string().optional(),
    effortRequired: z.string().optional(),
    homeboundDetermination: z.string().optional(),
});
export const baseHomeboundRefined = baseHomebound.superRefine((data, ctx) => {
    if (!data.homeboundConditions?.length) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'required',
            path: ['homeboundConditions'],
        });
    }
    if (!data.effortRequired?.trim() || data.effortRequired.trim().length < 80) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Minimum 80 characters required',
            path: ['effortRequired'],
        });
    }
    if (!data.homeboundDetermination?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'required',
            path: ['homeboundDetermination'],
        });
    }
    if (data.homeboundConditions?.includes('Other') && !data.homeboundConditionsOther?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'required',
            path: ['homeboundConditionsOther'],
        });
    }
    if (data.effortFactors?.includes('Other') && !data.effortFactorsOther?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'required',
            path: ['effortFactorsOther'],
        });
    }
});
